import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";
import { getContactUs, getSection, getSingleHiring } from "store/actions";
import Loader from "components/shared/Loader";
import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";

const ShowHiring = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const {
    loading,
    error,
    singleHiring: section,
  } = useSelector((state) => state.hiring);

  const { formatMessage, locale } = useIntl();

  useEffect(() => {
    dispatch(getSingleHiring(id));
  }, [dispatch, id]);

  // error
  useEffect(() => {
    if (error) {
      toastErrorMessage(formatMessage({ id: "sendingErrorMessage" }), locale);
    }
  }, [error, formatMessage, locale]);

  function formateDate(isoString) {
    const date = new Date(isoString);
    return date.toISOString().split("T")[0];
  }

  const handleDownload = async (link) => {
    const response = await fetch(link);
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);

    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.target = "_blank";
    anchor.download = "downloaded-file";
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
    window.URL.revokeObjectURL(url);
  };

  if (loading) return <Loader />;
  return (
    <>
      <div className="acc-form">
        <div className="card job-details">
          <div className="card-head">
            <h4>
              <FormattedMessage id={"showContact"} />
            </h4>
          </div>
          <div className="card-body table-details--">
            <div className="table-responsive">
              <table className="table table-bordered">
                <tbody>
                  <tr>
                    <td>
                      <FormattedMessage id={"name"} />
                    </td>
                    <td>
                      {section?.name || section?.firstName || section?.fullName}{" "}
                    </td>
                  </tr>
                  {/* <tr>
                    <td>
                      <FormattedMessage id={"lastName"} />
                    </td>
                    <td>{section?.subject || section?.lastName} </td>
                  </tr> */}
                  <tr>
                    <td>
                      <FormattedMessage id={"email"} />
                    </td>
                    <td>{section?.email} </td>
                  </tr>
                  <tr>
                    <td>
                      <FormattedMessage id={"phone"} />
                    </td>
                    <td>{section?.phone} </td>
                  </tr>
                  <tr>
                    <td>
                      <FormattedMessage id={"birthDate"} />
                    </td>
                    {section?.birthDate && (
                      <td>{formateDate(section?.birthDate)} </td>
                    )}
                  </tr>
                  <tr>
                    <td>
                      <FormattedMessage id={"driverLiceneseNumber"} />
                    </td>
                    <td>{section?.driverLicenseNumber} </td>
                  </tr>
                  <tr>
                    <td>
                      <FormattedMessage id={"nationalId"} />
                    </td>
                    <td>{section?.nationalId} </td>
                  </tr>

                  <tr>
                    <td>
                      <FormattedMessage id={"nationalIdImage"} />
                    </td>
                    <td className="d-flex align-items-center flex-wrap">
                      <img
                        src={section?.nationalIdImage}
                        alt="nationalIdImage"
                        className="store-logo"
                      />
                      <button
                        type="button"
                        className="btn ms-2 d-flex align-items-center gap-2"
                        style={{ backgroundColor: "#407c5a", color: "#fff" }}
                        onClick={() => handleDownload(section?.nationalIdImage)}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="#fff"
                          className="bi bi-download"
                          viewBox="0 0 16 16"
                        >
                          <path d="M.5 9.9a.5.5 0 0 1 .5.5v3.1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-3.1a.5.5 0 0 1 1 0v3.1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-3.1a.5.5 0 0 1 .5-.5z" />
                          <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3.5-3.5a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 7.646a.5.5 0 1 0-.708.708l3 3z" />
                        </svg>
                        <FormattedMessage id={"download"} />
                      </button>
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <FormattedMessage id={"driverLicenseImage"} />
                    </td>
                    <td className="d-flex align-items-center flex-wrap">
                      <img
                        src={section?.driverLicenseImage}
                        alt="driverLicenseImage"
                        className="store-logo"
                      />
                      <button
                        type="button"
                        className="btn ms-2 d-flex align-items-center gap-2"
                        onClick={() =>
                          handleDownload(section?.driverLicenseImage)
                        }
                        style={{ backgroundColor: "#407c5a", color: "#fff" }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="#fff"
                          className="bi bi-download"
                          viewBox="0 0 16 16"
                        >
                          <path d="M.5 9.9a.5.5 0 0 1 .5.5v3.1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-3.1a.5.5 0 0 1 1 0v3.1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-3.1a.5.5 0 0 1 .5-.5z" />
                          <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3.5-3.5a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 7.646a.5.5 0 1 0-.708.708l3 3z" />
                        </svg>
                        <FormattedMessage id={"download"} />
                      </button>
                    </td>
                  </tr>
                  {section?.carInfo && section?.hasCar && (
                    <tr>
                      <td>
                        <FormattedMessage id={"car-model"} />
                      </td>
                      <td>{section?.carInfo?.carModel}</td>
                    </tr>
                  )}
                  {section?.carInfo && section?.hasCar && (
                    <tr>
                      <td>
                        <FormattedMessage id={"plate-number"} />
                      </td>
                      <td>{section?.carInfo?.plateNumber}</td>
                    </tr>
                  )}
                  {section?.carInfo && section?.hasCar && (
                    <tr>
                      <td>
                        <FormattedMessage id={"registration-image"} />
                      </td>
                      <td className="d-flex align-items-center flex-wrap">
                        <img
                          src={section?.carInfo?.registrationImage}
                          alt="registrationImage"
                          className="store-logo"
                        />
                        <button
                          type="button"
                          className="btn ms-2 d-flex align-items-center gap-2"
                          style={{ backgroundColor: "#407c5a", color: "#fff" }}
                          onClick={() =>
                            handleDownload(section?.carInfo?.registrationImage)
                          }
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="#fff"
                            className="bi bi-download"
                            viewBox="0 0 16 16"
                          >
                            <path d="M.5 9.9a.5.5 0 0 1 .5.5v3.1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-3.1a.5.5 0 0 1 1 0v3.1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-3.1a.5.5 0 0 1 .5-.5z" />
                            <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3.5-3.5a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 7.646a.5.5 0 1 0-.708.708l3 3z" />
                          </svg>
                          <FormattedMessage id={"download"} />
                        </button>
                      </td>
                    </tr>
                  )}

                  <tr>
                    <td>
                      <FormattedMessage id={"location"} />
                    </td>
                    <td>
                      {section?.location?.locationTitle?.[locale] || "لايوجد"}{" "}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ShowHiring;
